import { makeStyles } from '@material-ui/styles';

export const useStyles = makeStyles((theme) => ({
  page: {
    minHeight: 'calc(100vh - 5rem)',
    backgroundColor: '#ffffff',
    fontFamily: theme.typography.fontFamily,
  },
  content: {
    maxWidth: 1120,
    margin: '0 auto',
    padding: '48px 32px 80px',
    display: 'grid',
    gridTemplateColumns: 'minmax(0, 1.1fr) minmax(0, 0.9fr)',
    columnGap: 56,
    alignItems: 'start',
    ['@media (max-width: 900px)']: {
      gridTemplateColumns: '1fr',
      padding: '24px 16px 48px',
      rowGap: 40,
    },
  },
  leftColumn: {
    paddingRight: 24,
    ['@media (max-width: 900px)']: {
      paddingRight: 0,
      order: 2,
    },
  },
  rightColumn: {
    borderLeft: '1px solid #e6e6e6',
    paddingLeft: 48,
    position: 'sticky',
    top: 32,
    ['@media (max-width: 900px)']: {
      borderLeft: 'none',
      paddingLeft: 0,
      position: 'static',
      order: 1,
      paddingBottom: 16,
      borderBottom: '1px solid #e6e6e6',
    },
  },
  step: {
    marginBottom: 48,
  },
  stepTitle: {
    fontSize: 22,
    fontWeight: 700,
    color: '#1a1a1a',
    margin: 0,
  },
  stepTitleInactive: {
    fontSize: 22,
    fontWeight: 600,
    color: '#c4c4c4',
    margin: '0 0 40px',
  },
  stepTitleRow: {
    display: 'flex',
    alignItems: 'center',
    gap: 8,
    marginBottom: 8,
  },
  completedIcon: {
    color: theme.palette.primary.main,
    fontSize: 22,
  },
  stepDescription: {
    fontSize: 14,
    color: '#8a8a8a',
    margin: '8px 0 20px',
    lineHeight: 1.5,
  },
  authButtons: {
    display: 'flex',
    gap: 12,
    flexWrap: 'wrap',
  },
  primaryButton: {
    minWidth: 150,
    textTransform: 'none',
    fontWeight: 600,
    padding: '8px 20px',
    boxShadow: 'none',
    '&:hover': {
      boxShadow: 'none',
    },
  },
  secondaryButton: {
    minWidth: 150,
    textTransform: 'none',
    fontWeight: 600,
    padding: '8px 20px',
    borderWidth: 1,
    '&:hover': {
      borderWidth: 1,
    },
  },
  formControl: {
    fontFamily: theme.typography.fontFamily,
    marginBottom: '1rem',
    width: '100%',
  },
  register: {
    marginTop: '1rem',
    border: `2px solid ${theme.palette.primary.main}`,
    '&:hover, &:focus': {
      border: `2px solid ${theme.palette.primary.main}`,
    },
  },
  authForm: {
    maxWidth: 420,
    marginTop: 8,
  },
  backLink: {
    display: 'inline-block',
    marginTop: 12,
    cursor: 'pointer',
    fontSize: 14,
  },
  customerBox: {
    display: 'flex',
    flexDirection: 'column',
    gap: 4,
    marginTop: 12,
  },
  customerName: {
    fontSize: 15,
    fontWeight: 600,
    color: '#1a1a1a',
  },
  customerEmail: {
    fontSize: 14,
    color: '#6b6b6b',
  },
  cardElementBox: {
    border: '1px solid #d0d0d0',
    borderRadius: 8,
    padding: '14px 12px',
    marginBottom: 16,
    backgroundColor: '#fafafa',
  },
  stripeHint: {
    fontSize: 13,
    color: '#8a8a8a',
    margin: '0 0 16px',
  },
  errorText: {
    fontSize: 13,
    color: theme.palette.error.main,
    margin: '0 0 12px',
  },
  payButton: {
    textTransform: 'none',
    fontWeight: 600,
    padding: '10px 20px',
    boxShadow: 'none',
    '&:hover': {
      boxShadow: 'none',
    },
  },
  summaryTitle: {
    fontSize: 20,
    fontWeight: 700,
    color: '#1a1a1a',
    margin: '0 0 28px',
  },
  productRow: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: 16,
    marginBottom: 28,
  },
  productImage: {
    width: 64,
    height: 64,
    borderRadius: 8,
    objectFit: 'cover',
    backgroundColor: '#eef3f8',
    flexShrink: 0,
  },
  productInfo: {
    flex: 1,
    minWidth: 0,
  },
  productNameRow: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    gap: 12,
  },
  productName: {
    fontSize: 15,
    color: '#1a1a1a',
    margin: 0,
  },
  productPrice: {
    fontSize: 15,
    color: '#1a1a1a',
    whiteSpace: 'nowrap',
    textAlign: 'right',
    margin: 0,
  },
  productInterval: {
    display: 'block',
    fontSize: 12,
    color: '#8a8a8a',
    textAlign: 'right',
    marginTop: 2,
  },
  productDescription: {
    fontSize: 13,
    color: '#8a8a8a',
    margin: '6px 0 0',
    lineHeight: 1.4,
  },
  promoBox: {
    display: 'flex',
    alignItems: 'center',
    gap: 10,
    backgroundColor: '#f3f3f3',
    borderRadius: 8,
    padding: '14px 16px',
    marginBottom: 28,
    cursor: 'pointer',
    color: theme.palette.primary.main,
    fontSize: 14,
    fontWeight: 500,
  },
  promoIcon: {
    fontSize: 20,
    color: '#6b6b6b',
  },
  promoForm: {
    display: 'flex',
    gap: 8,
    marginBottom: 28,
  },
  totals: {
    display: 'flex',
    flexDirection: 'column',
    gap: 12,
  },
  totalRow: {
    display: 'flex',
    justifyContent: 'space-between',
    fontSize: 14,
    color: '#1a1a1a',
  },
  totalFinal: {
    display: 'flex',
    justifyContent: 'space-between',
    fontSize: 18,
    fontWeight: 700,
    color: '#1a1a1a',
    marginTop: 8,
    paddingTop: 16,
    borderTop: '1px solid #eeeeee',
  },
  footerNote: {
    fontSize: 12,
    color: '#8a8a8a',
    marginTop: 28,
    lineHeight: 1.5,
  },
  successBox: {
    maxWidth: 480,
  },
  successTitle: {
    fontSize: 22,
    fontWeight: 700,
    color: '#1a1a1a',
    margin: '0 0 12px',
  },
  successText: {
    fontSize: 15,
    color: '#6b6b6b',
    margin: '0 0 24px',
    lineHeight: 1.5,
  },
  plansLayout: {
    maxWidth: 1100,
    margin: '0 auto',
    padding: '48px 32px 80px',
    ['@media (max-width: 900px)']: {
      padding: '24px 16px 48px',
    },
  },
  plansTitle: {
    fontSize: 28,
    fontWeight: 700,
    color: '#1a1a1a',
    margin: '0 0 8px',
  },
  plansSubtitle: {
    fontSize: 15,
    color: '#6b6b6b',
    margin: '0 0 32px',
    maxWidth: 560,
    lineHeight: 1.5,
  },
  plansGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(3, minmax(0, 1fr))',
    gap: 24,
    ['@media (max-width: 900px)']: {
      gridTemplateColumns: '1fr',
    },
  },
  planCard: {
    padding: 24,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    minHeight: 280,
    borderRadius: 12,
  },
  planCardName: {
    fontSize: 20,
    fontWeight: 700,
    color: theme.palette.primary.main,
    margin: '0 0 12px',
  },
  planCardDescription: {
    fontSize: 14,
    color: '#6b6b6b',
    lineHeight: 1.5,
    margin: 0,
  },
  planCardPrice: {
    fontSize: 24,
    fontWeight: 700,
    color: '#1a1a1a',
    margin: '24px 0 16px',
  },
  planCardInterval: {
    display: 'block',
    fontSize: 13,
    fontWeight: 400,
    color: '#8a8a8a',
    marginTop: 4,
  },
  productInitials: {
    width: 64,
    height: 64,
    borderRadius: 8,
    backgroundColor: theme.palette.primary.main,
    color: '#ffffff',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontWeight: 700,
    fontSize: 18,
    flexShrink: 0,
  },
  emptyState: {
    maxWidth: 520,
    margin: '0 auto',
    padding: '64px 24px',
    textAlign: 'center',
  },
}));
